export const TEST_ID = 'readyStatusBadge';
